import { Button, IconClose16 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FullscreenBannerContent = function FullscreenBannerContent(_ref) {
  var url = _ref.url,
    handleAccept = _ref.handleAccept,
    closeBanner = _ref.closeBanner;
  React.useEffect(function () {
    document.documentElement.classList.add(styles['disabled-scroll']);
    document.body.classList.add(styles['disabled-scroll']);
    return function () {
      document.documentElement.classList.remove(styles['disabled-scroll']);
      document.body.classList.remove(styles['disabled-scroll']);
    };
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    "data-name": "FullscreenBanner",
    children: /*#__PURE__*/_jsxs("div", {
      className: styles['content'],
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['close'],
        onClick: closeBanner,
        "data-name": "\u0421loseBtn",
        children: /*#__PURE__*/_jsx(IconClose16, {
          color: "white_100"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles['logo']
      }), /*#__PURE__*/_jsx("div", {
        className: styles['image-phone']
      }), /*#__PURE__*/_jsxs("div", {
        className: styles['footer'],
        children: [/*#__PURE__*/_jsx("span", {
          className: styles['title'],
          children: "\u0412 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 \u0443\u0434\u043E\u0431\u043D\u0435\u0435"
        }), /*#__PURE__*/_jsx("span", {
          className: styles['text'],
          children: "\u0422\u043E\u0447\u043D\u044B\u0435 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438 \u0438 \u0444\u0438\u043B\u044C\u0442\u0440\u044B, \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0438\xA0\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043E\u0431\xA0\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u0445"
        }), /*#__PURE__*/_jsx("a", {
          className: styles['link'],
          href: url,
          onClick: handleAccept,
          "data-name": "DownloadBtn",
          children: /*#__PURE__*/_jsx(Button, {
            fullWidth: true,
            theme: "fill_primary",
            size: "L",
            children: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C"
          })
        })]
      })]
    })
  });
};